import type { DocSection } from '../types'
import { FIG_CALLBACKS } from '../figures'

export const callbacksSection: DocSection = {
  id: 'rappels',
  title: 'Rappels & rendez-vous',
  icon: 'clock',
  accent: '#F59E0B',
  summary: 'Programmer un rappel, gérer ses rappels en retard, et prendre un rendez-vous.',
  minRole: 'agent',
  articles: [
    {
      id: 'programmer',
      title: 'Programmer un rappel',
      summary: 'Faire revenir un numéro à une date/heure précise.',
      icon: 'clock',
      blocks: [
        { type: 'p', text: "Un **rappel** fait revenir un numéro à un moment choisi (le contact a demandé « rappelez-moi demain à 14 h »). Deux façons de le créer :" },
        { type: 'list', items: [
          "À la **qualification**, choisissez une disposition de type **Reprogrammer** (ex. « Suite à donner ») : on vous demande la **date/heure** du rappel.",
          "Ou utilisez l'action **Programmer un rappel** directement sur la fiche.",
        ] },
        { type: 'p', text: "Le rappel vous est **nominatif** : il vous revient à vous (sauf réaffectation par un responsable)." },
      ],
    },
    {
      id: 'gerer',
      title: 'La page Rappels',
      summary: 'Voir et passer vos rappels du jour, à venir, en retard.',
      icon: 'calendar',
      blocks: [
        { type: 'p', text: "La page **Rappels** (barre latérale) regroupe vos rappels par échéance : aujourd'hui, à venir, en retard." },
        { type: 'figure', svg: FIG_CALLBACKS, alt: 'Page Rappels avec la liste des rappels', caption: "Vos rappels, triés par échéance. Un clic sur « Appeler » prépare le numéro." },
        { type: 'h', text: 'Ce que fait PexiTalk pour vous' },
        { type: 'list', items: [
          "**Pré-alerte** : 5 minutes avant l'échéance, une notification vous prévient.",
          "**À l'échéance, si vous êtes Disponible et libre** : le numéro est **préparé** dans le softphone et vous êtes notifié. ⚠️ L'appel **n'est jamais composé tout seul** — vous appuyez sur Appeler.",
          "Un **badge rouge** dans la barre latérale compte vos rappels **en retard**.",
        ] },
        { type: 'callout', variant: 'info', title: 'Côté superviseur', text: "Un responsable est alerté (en rouge) si un rappel échu a son agent **indisponible**, pour le réaffecter ou intervenir." },
      ],
    },
    {
      id: 'rdv',
      title: 'Prendre un rendez-vous',
      summary: 'Le formulaire RDV et la différence avec un simple rappel.',
      icon: 'check-circle',
      blocks: [
        { type: 'p', text: "Un **rendez-vous (RDV)** est un résultat positif où vous décrochez un engagement (démonstration, visite, signature). C'est **différent d'un rappel** : un rappel est juste « rappeler ce numéro plus tard »." },
        { type: 'steps', items: [
          "Qualifiez l'appel avec la disposition **RDV** (type « Réussi, positif »).",
          "Si la campagne a un **formulaire de RDV**, il s'affiche : renseignez les informations demandées (date, lieu, contact, détails).",
          "Validez : le rendez-vous est créé et apparaît dans la page **Rendez-vous**.",
        ] },
        { type: 'callout', variant: 'tip', title: 'Mémo date', text: "Selon la configuration, un RDV peut aussi être créé via une simple date saisie, sans formulaire complet. Dans tous les cas, l'enregistrement de l'appel est **conservé**." },
        { type: 'callout', variant: 'info', text: "Dans la page **Rendez-vous**, un agent voit **ses propres** RDV ; les responsables voient ceux de l'équipe avec filtres et statistiques." },
      ],
    },
  ],
}
